import globalData from "./global.js";
var socketOpen = false
var ping = 0
var Ws = null
var ws = null
var send_cache = []
var pong_time = 0
var game_id = 0
var self_color = 0
var reconn_on = true
var on_msg_handels = {}
var lockReconnect = false; //避免重复连接

function send(msg) {
	//let eve = msg.event
	//msg = JSON.stringify(msg)
	//if(['ping'].indexOf(msg.event)==-1) send_cache.push(msg)
	//reSend()
	/*uni.sendSocketMessage({
		data: JSON.stringify(msg),
		success() {
			//send_cache.splice(i,1)
		},
		fail() {

		}
	});*/
	if(socketOpen){
		ws.send(JSON.stringify(msg))
	}else{
		send_cache.push(msg)
	}
	
}



function reSend() {
	send_cache.forEach((v,k)=>{
		ws.send(JSON.stringify(v))
	})
	/*for(let i in send_cache){
		//send(send_cache[i])
		uni.sendSocketMessage({
			data: JSON.stringify(send_cache[i]),
			success() {
				send_cache.splice(i,1)
			},
			fail() {
				
			}
		});
		break;
	}*/
}

function reConnect() {
	if(lockReconnect) return
	lockReconnect = true;
	ws.close()
	socketOpen = false
	clearInterval(ping)
	setTimeout(()=>{
		pong_time=0
		getWebSocket(true)
		lockReconnect = false
	},20)
	
}

function close() {
	reconn_on = false
	//clearInterval(ping)
	//uni.closeSocket();
	ws.close()
}


function getWebSocket(is_reconn) {
	reconn_on = true
	if ("WebSocket" in window) {
		//alert("您的浏览器支持 WebSocket!");

		// 打开一个 web socket
		if(ws==null || is_reconn) ws = new WebSocket("wss://www.weiqi888.com:3011/duiju");
		//if(ws==null || is_reconn) {ws = new WebSocket("wss://localhost:3011/duiju");}

		ws.onopen = function () {
			socketOpen = true;
			reSend()
			if (is_reconn) {
				if (game_id && self_color) Ws.send({
					event: 'reconnect',
					game_id: game_id,
					color: self_color
				})
			}

			setTimeout(() => {
				if (!globalData.userInfo) return
				Ws.send({
					event: 'join_pool',
					user: {
						id: globalData.userInfo.id,
						school_id: globalData.userInfo.school_id,
						duiyi_level: globalData.userInfo.duiyi_level,
						need_pipei: 0,
						name: globalData.userInfo.name,
						wait: 0,
						reject_list: []
					},
					rev_color: globalData.rev_color,
					game_time: 20,
					b_size: 19
				})
			}, 2000)
		};

		ws.onmessage = function (evt) {
			let res = evt
			on_msg_handels['global'] = res => {
				res = JSON.parse(res.data)
				switch (res.event) {
					case 'po':
						reSend()
						pong_time = (new Date()).getTime()
						break;
					default:

				}
			}
			for (let i in on_msg_handels) {
				on_msg_handels[i](res)
			}
		};

		ws.onclose = function () {
			console.log('onclose')
			reConnect()
		};
		ws.onerror = function (e) {
			console.log(e)
			
		};
	}else {
		// 浏览器不支持 WebSocket
		console.error("您的浏览器不支持 WebSocket!");
	}
	
	ping = setInterval(()=> {
		ws.send(JSON.stringify({ event: 'pi' }))
		
		let cur_time = (new Date()).getTime()
		//心跳检测，一段时间没有收到pong,则重连
		if (pong_time > 0 && cur_time - pong_time > 12000) {reConnect() }
	}, 10000)

	Ws = {
		onMessage: (key, cb) => {
			on_msg_handels[key] = cb
		},//uni.onSocketMessage,
		send: send,
		close: close,
		setGameId: function (gid) {
			game_id = gid
		},
		setColor: function (color) {
			self_color = color
		},
		setReconn: function (val) {
			clearInterval(ping)
			reconn_on = val
		}
	}
	globalData.ws = Ws
	return Ws
}

function getWs() {
	return Ws
}

export default {
	getWebSocket: getWebSocket,
	getWs: getWs,
	reConnect: reConnect,
	reSend: reSend
}



// WEBPACK FOOTER //
// ./src/common/websocket.js